<app-nav [titulo]="titulo" [descripcion]="descripcion">
    <div class="producto-detalle">
        <mat-tab-group animationDuration="0" color="primary">
            <mat-tab label="Fianzas">
                <app-tipos-fianza [embedded]="true" [tipoProductoInicial]="tipoProducto"></app-tipos-fianza>
            </mat-tab>
            <mat-tab label="Coberturas">
                <app-coberturas [embedded]="true" [tipoProductoInicial]="tipoProducto"></app-coberturas>
            </mat-tab>
            <mat-tab label="Servicios Contratados">
                <app-servicios-contratados [embedded]="true" [tipoProductoInicial]="tipoProducto"></app-servicios-contratados>
            </mat-tab>
        </mat-tab-group>
    </div>
</app-nav>
